import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const wellness = (domain, resource) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => Authorization();

    return {
        saveMood: (data) => executeCall(() =>
            Axios.post(`${url}/mood`, data, { headers: getHeaders() })
        ),
        getMoodHistory: (days = 7) => executeCall(() =>
            Axios.get(`${url}/mood/history?days=${days}`, { headers: getHeaders() })
        ),
        saveJournal: (data) => executeCall(() =>
            Axios.post(`${url}/journal`, data, { headers: getHeaders() })
        ),
        getJournal: (days = 30) => executeCall(() =>
            Axios.get(`${url}/journal?days=${days}`, { headers: getHeaders() })
        ),
        logSos: (data) => executeCall(() =>
            Axios.post(`${url}/sos`, data, { headers: getHeaders() })
        ),
        saveActivity: (data) => executeCall(() =>
            Axios.post(`${url}/activity`, data, { headers: getHeaders() })
        ),
        getAlerts: () => executeCall(() =>
            Axios.get(`${url}/alerts`, { headers: getHeaders() })
        ),
        getPatientSummary: (clientId, days = 30) => executeCall(() =>
            Axios.get(`${url}/patient/${clientId}/summary?days=${days}`, { headers: getHeaders() })
        ),
    };
};

export default wellness;
